import React from 'react';
import useLanguage from '../hooks/useLanguage';

// Read-only photo grid shared by the Maintenance card and the Edit Task modal.
// Renders nothing when there are no photos.

const PHOTO_TYPE_COLORS = {
  before: '#2196F3',
  after: '#4CAF50',
  issue: '#FF5722',
  completion: '#471396'
};

const TaskPhotoGrid = ({ photos }) => {
  const { t } = useLanguage();

  if (!photos || photos.length === 0) return null;

  return (
    <div className="mt-2">
      <div className="small text-muted mb-1">{t('tasks.photos.evidenceTitle')} ({photos.length})</div>
      <div className="d-flex flex-wrap gap-2">
        {photos.map((photo, idx) => (
          <a
            key={photo._id || idx}
            href={photo.url}
            target="_blank"
            rel="noopener noreferrer"
            style={{
              position: 'relative',
              width: '72px',
              height: '54px',
              borderRadius: '6px',
              overflow: 'hidden',
              border: `2px solid ${PHOTO_TYPE_COLORS[photo.type] || '#dee2e6'}`,
              display: 'block'
            }}
          >
            <img
              src={photo.url}
              alt={photo.caption || `${photo.type} ${idx + 1}`}
              style={{ width: '100%', height: '100%', objectFit: 'cover' }}
            />
            <span
              style={{
                position: 'absolute',
                bottom: 0,
                left: 0,
                right: 0,
                fontSize: '0.6rem',
                fontWeight: 600,
                textAlign: 'center',
                color: '#fff',
                background: PHOTO_TYPE_COLORS[photo.type] || '#666',
                padding: '1px 0',
                lineHeight: 1.2
              }}
            >
              {t(`tasks.photos.${photo.type}`)}
            </span>
          </a>
        ))}
      </div>
    </div>
  );
};

export default TaskPhotoGrid;
